module.exports = {
	"articleTitle1": "Best New Restaurant: HopCat ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "HopCat",
	"articleLink1": "https://www.michigandaily.com/section/arts/best-new-restaurant-hopcat",
	"articleLink2": "https://www.michigandaily.com/news/craft-beer-bar-opens-downtown",
	"articleSnippet1": "Apr 1, 2016 ... If you are looking for the newest foodie adventure in Ann Arbor, head over to \nMaynard and discover all that HopCat has to offer. It may look like ...",
	"articleSnippet2": "Feb 15, 2015 ... Leading up to the event, HopCat advertised that it would offer free “crack fries,” a \nsignature dish of beer-battered French fries, during the grand ...",
	"foodRecommendations": [
		{
			"text": "The crack fries are as addictive and nearly as dangerous as their namesake",
			"person": "Nick Kortman"
		}
	],
	"articleTitle2": "HopCat grand opening draws hundreds with local craft beer",
	"address": "311 Maynard St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/agc.NEW_.HopcatBOAA.3.31.16.012.jpg?itok=MB6jZ_un",
			"author": "Amelia Cacchione",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.2791,
		"lng": -83.7418
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/hopcat.json
// module id = 892
// module chunks = 0